function navigate(path: string): void {
  window.history.pushState({}, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
}

export function initNavigation(): void {
  document.addEventListener('click', (e) => {
    if (e.defaultPrevented || e.button !== 0) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const anchor = (e.target as HTMLElement).closest('a[href]');
    if (!anchor) return;
    const href = anchor.getAttribute('href');
    if (!href) return;
    if (anchor.target === '_blank' || anchor.hasAttribute('download')) return;
    if (href.startsWith('http') && !href.startsWith(window.location.origin)) return;
    e.preventDefault();
    navigate(href.startsWith('http') ? href.substring(window.location.origin.length) : href);
  });
}
